import List from '../components/Worker/ActionPlan/List'
import Answer from '../components/Worker/ActionPlan/Answer'

let routes = {
    path: '/worker/actionPlans',
    component: resolve => require(['../components/layout/Basic/App'], resolve),
    children: [
      {
          path: '/worker/actionPlans',
          name: 'Planos de Ação',
          component: List
      },
      {
        path: '/worker/actionPlan/:id',
        name: 'Plano de Ação',
        component: Answer
    },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/actionPlanWorker.js